import { css } from '@compiled/react';

import { LoomOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { JoinableSites } from '@/components/signup/site-activation/components/common/joinable-sites';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import { COHORTS, useCohort } from '@/components/user-context/helpers/cohorts';

import { Headings } from '../../components/headings';
import { JoinableSitesText } from '../../components/joinable-sites-subheading';
import { ReturnToProductText } from '../../components/return-to-product-subheading';
import { WelcomeBackText } from '../../components/welcome-back-heading';

// Loom logged-in signup for users who already have sites. Mirrors the
// Jira/Confluence structure (boxed multi-site list with "Go to <product>"
// cards, "Switch account", and "or start a new site") by routing through the
// shared SiteActivation switcher with contact-expand cohort logic, while
// keeping the Loom backdrop (LoomOverlayTemplate) and Loom copy.
//
// Byline matches Jira/Confluence per cohort: the joinable-user path shows
// "Select where you'd like to get started." (JoinableSitesText); all other
// returning-user cohorts show "Pick up where you left off." (ReturnToProductText).
export const LoggedInLoomExistingSitesUser = () => {
	const cohort = useCohort(true);
	const subHeading =
		cohort === COHORTS.CURRENT_PRODUCT_JOINABLE_USER ? (
			<JoinableSitesText />
		) : (
			<ReturnToProductText />
		);

	return (
		<LoomOverlayTemplate size="sm">
			<div css={containerCss}>
				<Headings main={<WelcomeBackText />} sub={subHeading} />
				<SiteActivation
					CurrentProductUser={<ReturnToProduct />}
					CurrentProductJoinableUser={<JoinableSites />}
					useContactExpandCohortLogic
				/>
			</div>
		</LoomOverlayTemplate>
	);
};

const containerCss = css({
	display: 'grid',
	gap: '10px',
});
